import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "snackbar__container max--width" }
const _hoisted_2 = {
  key: 0,
  class: "loader__container"
}
const _hoisted_3 = { class: "loader max--width--padded" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "lds-roller" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div")
], -1)
const _hoisted_5 = {
  key: 0,
  class: "loader__message"
}
const _hoisted_6 = { class: "view__container max--width" }
const _hoisted_7 = { class: "view" }

import { useRoute } from 'vue-router';
import {
  ref, watch, computed, onMounted, onUnmounted,
} from 'vue';
import Cookies from 'js-cookie';
import { useI18n } from 'vue-i18n';
import useSnackbar from '@/util/useHooks/useSnackbar';
import LKFHeader from '@/components/LKFHeader.vue';
import LKFFooter from '@/components/LKFFooter.vue';
import LKFSnackbar from '@/components/LKFSnackbar.vue';
import LKFPagination from '@/components/LKFPagination.vue';
import LKFCookieBar from '@/components/LKFCookiebar.vue';
import { useStore } from '@/store';
import { getIncidentMessageStatus } from '@/services/incidentParty';

const SMS_NOTIFICATION_DISPLAYED_COOKIE = 'SMSloaded';

export default /*#__PURE__*/_defineComponent({
  __name: 'Layout',
  setup(__props) {

const { snackbars } = useSnackbar();
const { t, locale } = useI18n();
const store = useStore();

const route = useRoute();
const setTitle = (): void => {
  let viewName = route.name?.toString() ?? 'fallback';
  if (viewName === 'IncidentToken') {
    viewName = 'CatchAll';
  }
  viewName = `${viewName.substring(0, 1).toLowerCase()}${viewName.substring(1)}`;
  document.title = `${t(`views.${viewName}.pageTitle`)} - LKF`;
};
const cookieValue = ref(localStorage.getItem('LKFLS-self-check') ?? '0');
const { addSnackbar } = useSnackbar();

const mustShowPagination = computed<boolean>(() => {
  const viewName = route.name?.toString() ?? 'fallback';
  if (viewName === 'Confirmation' || route.params.name === 'Confirmation') return true;
  return cookieValue.value === `${route.params.incidentKey}/${route.params.partyKey}`;
});

onMounted(() => {
  cookieValue.value = localStorage.getItem('LKFLS-self-check') ?? '0';
});

watch([locale, route], setTitle);
setTitle();

const viewClasses = ref<string[]>([]);
const setViewClasses = () => {
  viewClasses.value = [];
  if (route.name === 'CatchAll' || route.name === 'IncidentToken') {
    viewClasses.value.push('view__app--not-found');
  }
};

watch(() => route.name, setViewClasses);
setViewClasses();

const intervalId = ref<number>();
const pingSms = async () => {
  const cookieName = `${SMS_NOTIFICATION_DISPLAYED_COOKIE}_${route.params.incidentKey}_${route.params.partyKey}`;
  if (Cookies.get(cookieName) !== '1') {
    const { data } = await getIncidentMessageStatus();
    const successMessages: Set<string> = new Set();
    const failedMessages: Set<string> = new Set();
    let anyPending = false;

    data.forEach((value) => {
      if (value.partyKey === route.params.partyKey) {
        if (value.sentStatus === 'SENT') {
          successMessages.add(value.licencePlate);
        } else if (value.sentStatus === 'FAILED') {
          failedMessages.add(value.licencePlate);
        } else {
          anyPending = true;
        }
      }
    });

    if (anyPending) {
      return;
    }

    if (successMessages.size) {
      successMessages.forEach((value) => {
        if (value === 'PROPERTY') {
          console.log('SENT', value, successMessages.values);
          addSnackbar({
            type: 'success',
            message: t('views.conclusion.smsSentSuccessfullyProperty', successMessages.size),
            timeout: 5000,
          });
        } else {
          addSnackbar({
            type: 'success',
            message: t('views.conclusion.smsSentSuccessfully', { vehicleIdentifiers: [...successMessages].join(', ') }, successMessages.size),
            timeout: 5000,
          });
        }
      });
    }

    if (failedMessages.size) {
      failedMessages.forEach((value) => {
        if (value === 'PROPERTY') {
          addSnackbar({
            type: 'error',
            message: t('views.conclusion.error.failedToSendSmsProperty', failedMessages.size),
            timeout: 5000,
          });
        } else {
          addSnackbar({
            type: 'error',
            message: t('views.conclusion.error.failedToSendSms', { vehicleIdentifiers: [...failedMessages].join(', ') }, failedMessages.size),
            timeout: 5000,
          });
        }
      });
    }

    if (successMessages.size || failedMessages.size) {
      Cookies.set(cookieName, '1', { expires: 1 });
    }
    clearInterval(intervalId.value);
  }
};

const startPingingSms = () => {
  intervalId.value = setInterval(pingSms, 5000);
};

onUnmounted(() => {
  clearInterval(intervalId.value);
});


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["view__app", viewClasses.value])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(snackbars), (snackbar) => {
        return (_openBlock(), _createBlock(LKFSnackbar, {
          key: snackbar.key,
          message: snackbar.message,
          type: snackbar.type,
          "button-text": snackbar.buttonText,
          "button-callback": snackbar.buttonCallback
        }, null, 8, ["message", "type", "button-text", "button-callback"]))
      }), 128))
    ]),
    (_unref(store).state.incident.loader.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            (_unref(store).state.incident.loader.loaderMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(store).state.incident.loader.loaderMessage), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(LKFCookieBar, { ref: "cookies" }, null, 512),
    _createElementVNode("section", _hoisted_6, [
      _createVNode(LKFHeader),
      _createElementVNode("main", _hoisted_7, [
        (_ctx.$route.meta.step as number > 0)
          ? (_openBlock(), _createBlock(LKFPagination, {
              key: 0,
              steps: 12,
              "current-step": _ctx.$route.meta.step as number,
              "force-pagination-visible": mustShowPagination.value
            }, null, 8, ["current-step", "force-pagination-visible"]))
          : _createCommentVNode("", true),
        (_openBlock(), _createBlock(_component_router_view, {
          key: _ctx.$route.path,
          onStartPingingSms: startPingingSms
        }))
      ]),
      _createVNode(LKFFooter)
    ])
  ], 2))
}
}

})